export default __webpack_public_path__ + "static/media/Q3-3.8d84cb21.png";